import * as ConstantRouter from '@/constant/router';
import * as ConstantLabel from '@/constant/label';
import loadable from '@/utils/loadable';

const route = {
  path: 'reports',
  name: ConstantRouter.REPORTS,
  component: loadable(() => import(/* webpackChunkName: "reports" */ '@/pages/reports/index.vue')),
  meta: {
    name: ConstantLabel.REPORTS,
    showUploadBox: true,
  },
  children: [
    {
      path: 'detail',
      name: ConstantRouter.DETAILEDREPORTS,
      component: loadable(
        () => import(/* webpackChunkName: "detailed-reports" */ '@/pages/reports/index.vue'),
      ),
      meta: {
        name: ConstantLabel.DETAILEDREPORTS,
        showUploadBox: true,
      },
    },
  ],
};

export default route;
